import { useCallback, useEffect, useState } from 'react';
import { trackSystemEntityEvent } from '../index';

const useOnResizeAnalytic = () => {
    const [devicePixelRatio, setDevicePixelRatio] = useState(window.devicePixelRatio);

    const trackZoomInOut = useCallback(() => {
        const currentDevicePixelRatio = window.devicePixelRatio; // if pixels ratio has changed - zoom happened
        const hasZoomHappened = devicePixelRatio !== currentDevicePixelRatio;
        if (hasZoomHappened) {
            const percent = Math.floor((window.outerWidth / window.innerWidth) * 100); // percentage of zoom
            trackSystemEntityEvent(
                'system_info',
                JSON.stringify({
                    zoom_explorer: currentDevicePixelRatio > devicePixelRatio ? 'IN' : 'OUT',
                    percent,
                    device_pixel_ratio: devicePixelRatio,
                })
            );

            setDevicePixelRatio(currentDevicePixelRatio);
        }
    }, [devicePixelRatio]);

    const onResizeEvent = useCallback(() => {
        trackZoomInOut();
    }, [trackZoomInOut]);

    useEffect(() => {
        window.addEventListener('resize', onResizeEvent);

        return () => {
            window.removeEventListener('resize', onResizeEvent);
        };
    }, [onResizeEvent]);
};

export default useOnResizeAnalytic;
